<template>
  <div class="meeting-type">
        <div class="d-flex justify-content-between mb-3">
            <div class="room-title">
                会议报价
            </div>
            <!-- <el-button class="mr-3" icon="el-icon-plus" type="primary" size="mini" @click="submitPost()">新增会议日期</el-button> -->
        </div>
        <!--房型标题-->
        <ul class="roomtypetitle" v-if="meeting_need_arr.length>0">
            <li  class="w-15">开会日期</li>
            <li class="roomtypetitle-information w-80" :class="{'w-90':modify}">
                <div v-for="(item,index) in modify?modifyroomtypetitle:roomtypetitle" :key="index" :style="{width:item.width}">
                    {{item.name}}
                </div>
            </li>
        </ul>
        <div class="room-rnk">
            <div class="roomtypetitle mt-3 roomtypetitle-bottom" v-for="(data,rowIdx) in meeting_need_arr" :key="data.value">
                <!--入住日期-->
                <div class=" w-15 content" >
                   {{ data.date/1000| formatTimestamp()}}
                </div>
                <div class="roomtypetitle-list w-80" :class="{'w-90':modify}">
                    <!--房间类型、间数、操作-->
                    <div  class="d-flex w-100">
                        <!--时间段-->
                        <div class=" w-30 content" >
                            {{ data.timeslot| formatVar('TimeSlots')}}
                        </div>
                        <!--布局-->
                        <div class=" w-20 content" >
                            {{ data.type| formatVar('LayoutTypes')}}
                        </div>
                        <!--人数-->
                        <div class=" w-20 content" >
                            {{ data.num}}人
                        </div>
                        <!--要求面积-->
                        <div class="w-20 content bordernone" >
                            {{ data.area}}㎡
                        </div>
                        <!--会议室-->
                        <el-select  
                            v-model="data.offer_title" 
                            placeholder="请选择或输入会议室"
                            filterable
                            allow-create
                            default-first-option
                            @change="getId($event,rowIdx)"
                            @blur="blurs($event,rowIdx)"
                            @input="onFieldChange" 
                            :class="{ roomRed: isFieldError(rowIdx, 'offer_title') }" 
                            class="w-50"  v-if="modify">
                            <el-option
                                v-for="roomItem in StoreMeetList"
                                :key="roomItem.title"
                                :label="roomItem.title"
                                :value="`${roomItem.id},${roomItem.title}`"
                            >
                            </el-option>
                        </el-select>
                        <!--单价-->
                        <el-input 
                        v-model.number="data.offer_price" 
                        placeholder="金额" 
                        class=" ml-2 w-30"
                        @input="onFieldChange" 
                        :class="{ roomRed: isFieldError(rowIdx, 'offer_price') }" 
                        type="number" v-if="modify">
                            <!-- <span slot="prepend">&yen;</span> -->
                            <span slot="append" class="lisxn">元</span>
                        </el-input>
                        <!--操作-->
                        <!-- <div class="w-30 deletes">
                            <i class="el-icon-delete" @click="splicse(rowIdx)"></i>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    meeting_need: {
      type: Array,
      default: () => []
    },
    modify: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
        meeting_need_arr:[],
        meetObjfs:{ date: '', timeslot: '', num: '',area:'', type: ''},
        roomtypetitle:[
            {name:'时间段',width:'50%'},
            {name:'布局',width:'50%'},
            {name:'出席人数',width:'50%'},
            {name:'要求面积 ',width:'50%'},
            {name:'操作',width:'30%'},
        ],
        modifyroomtypetitle:[
            {name:'时间段',width:'30%'},
            {name:'布局',width:'20%'},
            {name:'出席人数',width:'20%'},
            {name:'要求面积 ',width:'20%'},
            {name:'会议室 ',width:'50%'},
            {name:'单价 ',width:'40%'},
            // {name:'操作',width:'30%'},
        ],
         // 错误标记：精准记录 行+子项+字段名
        isSubmit:false,
        errorMap:{},
    };
  },
  computed: {
        ...mapState(['StoreMeetList']),
  },
  watch: {
    meeting_need: {
      handler(newVal) {
        this.meeting_need_arr = [...newVal];
      },
      deep: true, // 开启深度监听
      immediate: true // 一进页面就执行一次
    },
  },
  created() {},
  mounted() {},
  methods: {
    //确认订单
    submitForm(){
        this.isSubmit = true;
        const valid = this.validateAll();
        if (!valid) {
            this.$message.error('请填写完整的会议报价信息');
            return;
        }
        return this.meeting_need_arr;
    },
    // 全局校验，逐个字段判断
    validateAll() {
    this.errorMap = {};
    let pass = true;

    // 直接遍历一维数组 meeting_need_arr
    this.meeting_need_arr.forEach((item, rowIdx) => {
        // 固定校验 5 个字段
        const fields = this.modify?['date', 'timeslot', 'num', 'area', 'type','offer_price','offer_title']:['date', 'timeslot', 'num', 'area', 'type'];

        fields.forEach(field => {
        const val = item[field];
        if (!val || String(val).trim() === '') {
            this.setFieldError(rowIdx, field);
            pass = false;
        }
        });
    });

    return pass;
    },

    // 记录错误字段：key 格式 rowIdx|field
    setFieldError(rowIdx, field) {
    const key = `${rowIdx}|${field}`;
    this.errorMap[key] = true;
    },

    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        this.validateAll();
    },

    // 判断单个字段是否标红
    isFieldError(rowIdx, field) {
        if (!this.isSubmit) return false;
        const key = `${rowIdx}|${field}`;
        return !!this.errorMap[key];
    },
    // 禁用日期的回调函数，根据当前对象组和禁用日期的索引判断是否禁用日期
    forbiddenStartTime(item,index) {
        return {
          // 在禁用日期的回调中使用index
          disabledDate: (date) => {
            let meetObj=[...this.room_need]
            //删除当前对象组
            meetObj.splice(index, 1);
            //判断是否有重复时间-重复布局 
            const allIndexes = meetObj.reduce((acc, user, index) => {
              if (user.type === item.type&&user.timeslot === item.timeslot) {
                acc.push(meetObj[index]); // 符合条件则添加索引到数组
              }
              return acc;
            }, []); // 初始值为空数组
            //判断禁用值
            let  hasTarget = allIndexes.some(user => user.date === date.getTime());
            return hasTarget
          }
        }
    },
    // 会议室相关
    getId(val,i){
        let [id, name] = val.split(',');
        let room_offer={...this.meeting_need_arr[i],offer_id:id?id:'0',offer_title:name?name:id};
        this.meeting_need_arr.splice(i, 1, room_offer);
        console.log(room_offer,'6789');
    },
    blurs(val,i){
        if(val.target.value){
            let room_offer={...this.meeting_need_arr[i],offer_id:'0',offer_title:val.target.value};
            this.meeting_need_arr.splice(i, 1, room_offer);
        }
    },
  }
};
</script>

<style lang="scss" scoped>
    .room-rnk{
        max-height: 200px;
        overflow-y: auto;
        scroll-behavior: smooth; 
    }
    .meeting-type{
        text-align: left;
    }
    .room-title{
        font-size: 16px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 2px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .roomtypetitle{
        display: flex;
        width: 100%;
        >li{
            text-align: center;
            font-size: 12px;
        }
    }
    .roomtypetitle-information{
        width: 70%;
        display: flex;
        text-align: center;
    }
    .roomtypetitle-list{
        width: 70%;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
    
    }
    .roomtypetitle-bottom{
        border-bottom: 1px #eee solid;
        padding-bottom: 14px;
    }
    .room-type-footer{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
    .deletes{
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: red;
        cursor: pointer;
    }
    .content{
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 12px;
        color: #999;
        // border: 1px solid #DCDFE6;
        border-radius: 4px;
        text-align: center;
        position: relative;
        &::after{
            content: '';
            position: absolute;
            right: 0;
            top: 10px;
            height: 20px;
            width: 1px;
            background-color: #DCDFE6;

        }
    }
    .bordernone{
         &::after{
            display: none;
         }
    }
</style>
<style>
    .meeting-type .el-date-editor.el-input{
        width: 100%;
    }
    .meeting-type .el-input__inner{
        text-align: center;
    }
    .meeting-type .el-input-group__append,.meeting-type .el-input--suffix .el-input__inner ,.meeting-type .el-input__inner{
        font-size: 12px;
    }
    .roomRed .el-input__inner,
    .roomRed .el-date-editor .el-input__inner {
    border-color: #F56C6C !important;
    }
</style>